import { reactQueryClient } from '../../web/ReactQueryProvider';
import { VOLUNTEER_CHARTS_KEY } from './useVolunteerCharts';
import { VOLUNTEERS_KEY } from './useVolunteers';
import { VOLUNTEER_SUMMARY_KEY } from './useVolunteerSummary';

/** Hours and participation feed the tiles, the charts and the volunteers list, so any attendance write stales all three. */
export const invalidateVolunteerReporting = () =>
	Promise.all(
		[VOLUNTEER_SUMMARY_KEY, VOLUNTEER_CHARTS_KEY, VOLUNTEERS_KEY].map(key =>
			reactQueryClient.invalidateQueries({ queryKey: [key] })
		)
	);
